import { render, staticRenderFns } from "./cardSettings.vue?vue&type=template&id=37ff73ca&scoped=true&"
import script from "./cardSettings.vue?vue&type=script&lang=js&"
export * from "./cardSettings.vue?vue&type=script&lang=js&"
import style0 from "./cardSettings.vue?vue&type=style&index=0&id=37ff73ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff73ca",
  null
  
)

component.options.__file = "cardSettings.vue"
export default component.exports